import { defineMessages } from 'react-intl'

const messages = defineMessages({
  dimension_0_Title: {
    id: 'AppTools.dimension_0_Title',
    description: 'Texto para el título del nivel',
    defaultMessage: 'Resultados de bienestar'
  },
  dimension_1_Title: {
    id: 'AppTools.dimension_1_Title',
    description: 'Texto para el título del nivel',
    defaultMessage: 'Resultados económico-empresariales'
  },
  dimension_2_Title: {
    id: 'AppTools.dimension_2_Title',
    description: 'Texto para el título del nivel',
    defaultMessage: 'Palancas dinámicas'
  },
  dimension_3_Title: {
    id: 'AppTools.dimension_3_Title',
    description: 'Texto para el título del nivel',
    defaultMessage: 'Contexto estructural'
  },

  dimension_0_Subtitle: {
    id: 'AppTools.dimension_0_Subtitle',
    description: 'Texto para el subtitulo del nivel',
    defaultMessage: 'En última instancia, la competittividad de un territorio se refleja en los resultados de bienestar que es capaza de generar. Organizamos los indicadores en varias subdimensiones de bienestar.'
  },
  dimension_1_Subtitle: {
    id: 'AppTools.dimension_1_Subtitle',
    description: 'Texto para el subtitulo del nivel',
    defaultMessage: 'Las dimensiones del desempeño económico-empresarial reflejan los resultados de las actividades empresariales y del conjunto del sistema económico de un territorio.'
  },
  dimension_2_Subtitle: {
    id: 'AppTools.dimension_2_Subtitle',
    description: 'Texto para el subtitulo del nivel',
    defaultMessage: 'Las palancas dinámicas inciden en el nivel de competitividad para el bienestar. Son elementos sobre los que hay más margen de actuación y cuya combinación afecta a los resultados económicos empresariales del territorio y al bienestar presente y futuro de las personas.'
  },
  dimension_3_Subtitle: {
    id: 'AppTools.dimension_3_Subtitle',
    description: 'Texto para el subtitulo del nivel',
    defaultMessage: 'El contexto estructural incluye las características del propio territorio, que son relativamente estables en el tiempo.'
  },

  subdimension_0_0_Title: {
    id: 'AppTools.subdimension_0_0_Title',
    description: 'Texto para el título del subdimensión 0.0',
    defaultMessage: 'Vida material'
  },
  subdimension_0_1_Title: {
    id: 'AppTools.subdimension_0_1_Title',
    description: 'Texto para el título del subdimensión 0.0',
    defaultMessage: 'Empleo'
  },
  subdimension_0_2_Title: {
    id: 'AppTools.subdimension_0_2_Title',
    description: 'Texto para el título del subdimensión 0.0',
    defaultMessage: 'Aprendizaje'
  },
  subdimension_0_3_Title: {
    id: 'AppTools.subdimension_0_3_Title',
    description: 'Texto para el título del subdimensión 0.0',
    defaultMessage: 'Salud'
  },
  subdimension_0_4_Title: {
    id: 'AppTools.subdimension_0_4_Title',
    description: 'Texto para el título del subdimensión 0.0',
    defaultMessage: 'Medioambiente'
  },

  subdimension_1_0_Title: {
    id: 'AppTools.subdimension_1_0_Title',
    description: 'Texto para el título del subdimensión 0.0',
    defaultMessage: 'Resultados económicos'
  },
  subdimension_1_1_Title: {
    id: 'AppTools.subdimension_1_1_Title',
    description: 'Texto para el título del subdimensión 0.0',
    defaultMessage: 'Rentabilidad empresarial'
  },

  subdimension_2_0_Title: {
    id: 'AppTools.subdimension_2_0_Title',
    description: 'Texto para el título del subdimensión 2.0',
    defaultMessage: 'Capital natural'
  },
  subdimension_2_1_Title: {
    id: 'AppTools.subdimension_2_1_Title',
    description: 'Texto para el título del subdimensión 2.0',
    defaultMessage: 'Capital físico'
  },
  subdimension_2_2_Title: {
    id: 'AppTools.subdimension_2_2_Title',
    description: 'Texto para el título del subdimensión 2.0',
    defaultMessage: 'Conocimiento'
  },
  subdimension_2_3_Title: {
    id: 'AppTools.subdimension_2_3_Title',
    description: 'Texto para el título del subdimensión 2.0',
    defaultMessage: 'Capital humano'
  },
  subdimension_2_4_Title: {
    id: 'AppTools.subdimension_2_4_Title',
    description: 'Texto para el título del subdimensión 2.0',
    defaultMessage: 'Capital social e institucional'
  },

  subdimension_3_0_Title: {
    id: 'AppTools.subdimension_3_0_Title',
    description: 'Texto para el título del subdimensión 3.0',
    defaultMessage: 'Geodemografía'
  },

  dataSource: {
    id: 'AppTools.dataSource',
    description: 'Texto para la fuente de los datos',
    defaultMessage: '<em>Fuente:</em> {dataSource}. Elaboración Orkestra.'
  },

  report_1_title: {
    id: 'AppTools.report_1_title',
    description: 'n/a',
    defaultMessage: 'Resultados económico-empresariales'
  },

  report_1_1_title: {
    id: 'AppTools.report_1_1_title',
    description: 'n/a',
    defaultMessage: 'Desempeño económico'
  },

  report_1_2_title: {
    id: 'AppTools.report_1_2_title',
    description: 'n/a',
    defaultMessage: 'Rentabilidad empresarial'
  },

  report_1_3_title: {
    id: 'AppTools.report_1_3_title',
    description: 'n/a',
    defaultMessage: 'Innovación y empredimiento'
  },

  report_1_4_title: {
    id: 'AppTools.report_1_4_title',
    description: 'n/a',
    defaultMessage: 'Internacionalización'
  },

  report_2_title: {
    id: 'AppTools.report_2_title',
    description: 'n/a',
    defaultMessage: 'Resultados de bienestar'
  },

  report_2_1_title: {
    id: 'AppTools.report_2_1_title',
    description: 'n/a',
    defaultMessage: 'Satisfacción con la vida'
  },

  report_2_2_title: {
    id: 'AppTools.report_2_2_title',
    description: 'n/a',
    defaultMessage: 'Vida material'
  },

  report_2_3_title: {
    id: 'AppTools.report_2_3_title',
    description: 'n/a',
    defaultMessage: 'Empleo'
  },

  report_2_4_title: {
    id: 'AppTools.report_2_4_title',
    description: 'n/a',
    defaultMessage: 'Vida social'
  },

  report_2_5_title: {
    id: 'AppTools.report_2_5_title',
    description: 'n/a',
    defaultMessage: 'Aprendizaje'
  },

  report_2_6_title: {
    id: 'AppTools.report_2_6_title',
    description: 'n/a',
    defaultMessage: 'Salud'
  },

  report_2_7_title: {
    id: 'AppTools.report_2_7_title',
    description: 'n/a',
    defaultMessage: 'Medioambiente'
  },

  report_3_title: {
    id: 'AppTools.report_3_title',
    description: 'n/a',
    defaultMessage: 'Palancas'
  },

  report_3_1_title: {
    id: 'AppTools.report_3_1_title',
    description: 'n/a',
    defaultMessage: 'Capital natural'
  },

  report_3_2_title: {
    id: 'AppTools.report_3_2_title',
    description: 'n/a',
    defaultMessage: 'Capital físico'
  },

  report_3_3_title: {
    id: 'AppTools.report_3_3_title',
    description: 'n/a',
    defaultMessage: 'Financiación'
  },

  report_3_4_title: {
    id: 'AppTools.report_3_4_title',
    description: 'n/a',
    defaultMessage: 'Conocimiento'
  },

  report_3_5_title: {
    id: 'AppTools.report_3_5_title',
    description: 'n/a',
    defaultMessage: 'Capital humano'
  },

  report_3_6_title: {
    id: 'AppTools.report_3_6_title',
    description: 'n/a',
    defaultMessage: 'Capital social'
  },

  report_0_title: {
    id: 'AppTools.report_0_title',
    description: 'n/a',
    defaultMessage: 'Contexto estructural'
  },

  report_0_1_title: {
    id: 'AppTools.report_0_1_title',
    description: 'n/a',
    defaultMessage: 'Geodemografía'
  },

  report_0_2_title: {
    id: 'AppTools.report_0_2_title',
    description: 'n/a',
    defaultMessage: 'Estructura económico empresarial'
  },
  
})

export default messages



// WEBPACK FOOTER //
// ./src/utils/app/messages.js